module.exports = __webpack_public_path__ + "img/VP-ProfiNew_Overview-GB-EB_1.fa816d16.jpg";